/* eslint-disable react-hooks/exhaustive-deps */
import { KTSVG } from '../../_metronic/helpers'
import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom';
import { Table } from 'react-bootstrap-v5';
import Swal from 'sweetalert2'
import { getRequestOptions, postRequestOptions } from '../helpers/Fetchwrapper'
import Select from 'react-select'
import { Link } from 'react-router-dom';
import validationErrorMsg from '../helpers/ValidationErrorMsg'
import { useHistory } from "react-router-dom";
import { numberFormat } from '../helpers/GlobalHelper';

interface PurchaseRows {
    idPoRows: number;
    idItems: number;
    idProducts: number;
    poQuantity: number;
    receivedQuantity: number;
    returnedQuantity: number;
    returnQuantity: number;
    quantity: number;
    rate: number;
    amount: number;
    [key: string]: any; // Index signature
}

interface Item {
    idItems: number;
    itemName: string;
}

interface PurchaseData {
    purchaseType: string;
    idProjects: number;
    idPo: number;
    idVendors: number;
    invoiceNo: string;
    idWarehouses?: number | string;
    purchaseDate: string;
    lcNo: string;
    chalanNo: string;
    chalanDate: string;
    remarks: string;
    purchaseAmount: number;
    vatPercentage: number;
    vatAmount: number;
    taxPercentage: number;
    taxAmount: number;
    creditDays?: number;
}



const PurchaseCreate = () => {
    // Get URL parameters
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const urlPurchaseType = searchParams.get('purchaseType');
    const urlIdProjects = searchParams.get('idProjects');
    const urlIdPo = searchParams.get('idPo');

    let history = useHistory();


    const purchaseData: PurchaseData = {
        purchaseType: urlPurchaseType || "Local Purchase",
        idProjects: urlIdProjects ? Number(urlIdProjects) : 0,
        idPo: urlIdPo ? Number(urlIdPo) : 0,
        idVendors: 0,
        invoiceNo: '',
        purchaseDate: '',
        lcNo: '',
        chalanNo: '',
        chalanDate: '',
        remarks: '',
        purchaseAmount: 0,
        vatPercentage: 0,
        vatAmount: 0,
        taxPercentage: 0,
        taxAmount: 0
    };

    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState({ label: 'Select Project', value: '' });
    const [po, setPo] = useState({ label: 'Select PO', value: '' });
    const [purchaseOrders, setPurchaseOrders] = useState<any[]>([]);

    const [vendors, setVendors] = useState([]);
    const [vendor, setVendor] = useState({ label: 'Select Vendor', value: '' });
    const [purchase, setPurchase] = useState(purchaseData);
    const [purchaseRows, setPurchaseRows] = useState<PurchaseRows[]>([{
        idPoRows: 0,
        idItems: 0,
        idProducts: 0,
        poQuantity: 0,
        receivedQuantity: 0,
        returnedQuantity: 0,
        returnQuantity: 0,
        quantity: 0,
        rate: 0,
        amount: 0,
    }]);

    const [poPurpose, setPoPurpose] = useState('Raw Materials');
    const isFinishedProduct = poPurpose === 'Finished Product';
    const nameColumnLabel = isFinishedProduct ? 'Product Name' : 'Item Name';

const [items, setItems] = useState<Item[]>([]);
// Warehouse dropdown state
const [warehouses, setWarehouses] = useState([]);
const [warehouse, setWarehouse] = useState({ label: 'Select Warehouse', value: '' });

    const formatProductLabel = (product: any) => {
        if (!product) return '';
        const packingUnit = [product.packing, product.item?.unit?.unitName].filter(Boolean).join(' ');
        return product.productCode
            ? `${product.productName}${packingUnit ? ' (' + packingUnit + ')' : ''} Code: ${product.productCode}`
            : `${product.productName || ''}${packingUnit ? ' (' + packingUnit + ')' : ''}`;
    };


    useEffect(() => {
        getProjects();
        getVendors();
        getItems();
    }, []);

    // Set project and PO dropdowns after options are loaded

    // --- Auto-select project and PO from URL params ---
    // Use a flag to avoid running PO selection on every purchaseOrders update
    const [poAutoSelectPending, setPoAutoSelectPending] = useState(false);

    useEffect(() => {
        if (projects.length && urlIdProjects) {
            const foundProject = projects.find((p: any) => Number(p.value) === Number(urlIdProjects));
            if (foundProject) {
                setProject(foundProject);
                getProjectPurchase(Number(urlIdProjects));
                getWarehousesByProject(Number(urlIdProjects));
                // Set flag to auto-select PO after purchaseOrders is loaded
                setPoAutoSelectPending(true);
            }
        }
        // eslint-disable-next-line
    }, [projects]);

    useEffect(() => {
        if (poAutoSelectPending && purchaseOrders.length && urlIdPo) {
            // Try to match by value, idPo, or id_po for robustness
            const foundPo = purchaseOrders.find((p: any) => {
                const v = p.value ?? p.idPo ?? p.id_po;
                return String(v) === String(urlIdPo);
            });
            if (foundPo) {
                setPo(foundPo);
                handlePoChange(foundPo); // Ensure PO info, vendor, and rows are loaded
                setPurchase((prev) => ({ ...prev, idPo: foundPo.value ?? foundPo.idPo ?? foundPo.id_po }));
            }
            setPoAutoSelectPending(false); // Only run once after project/PO load
        }
        // eslint-disable-next-line
    }, [purchaseOrders, poAutoSelectPending]);
    
    // Recalculate VAT & TAX when purchaseRows change
    useEffect(() => {
        if (purchaseRows.length > 0) {
            const totalAmount = calculateTotalAmount();
            setPurchase((prev) => {
                const vatPercentage = prev.vatPercentage || 0;
                const taxPercentage = prev.taxPercentage || 0;
                const vatAmount = (totalAmount * Number(vatPercentage)) / 100;
                const taxAmount = (totalAmount * Number(taxPercentage)) / 100;
                const purchaseAmount = totalAmount + vatAmount + taxAmount;
                
                return {
                    ...prev,
                    vatAmount: vatAmount,
                    taxAmount: taxAmount,
                    purchaseAmount: purchaseAmount
                };
            });
        }
        // eslint-disable-next-line
    }, [purchaseRows]);


    const getProjects = () => {
        fetch(
            process.env.REACT_APP_API_URL + 'lead/projects',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let projectObj = resp.data.map((item: any) => {
                    item.label = item.name;
                    item.value = item.id;
                    return item
                })
                setProjects(projectObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const getVendors = () => {

        fetch(
            process.env.REACT_APP_API_URL + 'vendors',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                let leadObj = resp.data.map((item: any) => {
                    item.label = item.vendorName;
                    item.value = item.idVendors;
                    return item
                })
                setVendors(leadObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }


    const getProjectPurchase = (idProjects: number) => {

        fetch(
            process.env.REACT_APP_API_URL + 'purchase/po/' + idProjects+'?purchaseType='+purchase.purchaseType,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {
                
                let poObj = resp.data.map((item: any) => {
                    item.label = item.referenceNo;
                    item.value = item.idPo;
                    return item
                })
                setPurchaseOrders(poObj);
            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }


    // Fetch warehouses by project
    const getWarehousesByProject = (idProjects: number) => {
        if (!idProjects) {
            setWarehouses([]);
            setWarehouse({ label: 'Select Warehouse', value: '' });
            return;
        }
        fetch(
            process.env.REACT_APP_API_URL + 'warehouse/' + idProjects + '/list',
            getRequestOptions()
        )
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success && Array.isArray(resp.data)) {
                    const whOptions = resp.data.map((item: any) => ({
                        label: item.name,
                        value: item.id_warehouses
                    }));
                    setWarehouses(whOptions);
                } else {
                    setWarehouses([]);
                }
                setWarehouse({ label: 'Select Warehouse', value: '' });
            })
            .catch(() => {
                setWarehouses([]);
                setWarehouse({ label: 'Select Warehouse', value: '' });
            });
    };

    const handleProjectChange = (project: any) => {
        setProject(project);
        getProjectPurchase(project.value);
        getWarehousesByProject(project.value);
        setPo({ label: 'Select PO', value: '' });
        setVendor({ label: 'Select Vendor', value: '' });
        setPurchaseRows([{
            idPoRows: 0,
            idItems: 0,
            idProducts: 0,
            poQuantity: 0,
            receivedQuantity: 0,
            returnedQuantity: 0,
            returnQuantity: 0,
            quantity: 0,
            rate: 0,
            amount: 0,
        }]);
        setPoPurpose('Raw Materials');
        setWarehouse({ label: 'Select Warehouse', value: '' });
        setPurchase({ ...purchase, idProjects: project.value, idPo: 0, lcNo: '', invoiceNo: '', idVendors: 0, vatPercentage: 0, vatAmount: 0, taxPercentage: 0, taxAmount: 0 });
    };

    const handleWarehouseChange = (selected: any) => {
        setWarehouse(selected);
        setPurchase({ ...purchase, idWarehouses: selected ? selected.value : '' });
    };

    const handlePoChange = (po: any) => {
        setPo(po);

        fetch(
            process.env.REACT_APP_API_URL + 'purchase/po-info/' + po.value,
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {

                const purpose = resp.purchase.purpose || 'Raw Materials';
                const finishedProduct = purpose === 'Finished Product';
                setPoPurpose(purpose);

                let poRows = [...resp.purchase.rows];
                poRows = poRows.map((row) => ({
                    idPoRows: row.id_po_rows,
                    idItems: row.id_items || 0,
                    idProducts: row.id_products || 0,
                    itemName: finishedProduct
                        ? formatProductLabel(row.product)
                        : (row.item?.itemName || ''),
                    itemCode: finishedProduct
                        ? (row.product?.productCode || '')
                        : (row.item?.itemCode || ''),
                    poQuantity: Number(row.poQuantity),
                    receivedQuantity: Number(row.receivedQuantity),
                    returnedQuantity: Number(row.returnedQuantity),
                    returnQuantity: 0,
                    quantity: Number(row.quantity),
                    rate: Number(row.rate),
                    amount: Number(row.quantity) * Number(row.rate)
                }));

                setVendor({ label: resp.purchase.vendor.vendorName, value: resp.purchase.id_vendors });
                
                // Auto-populate VAT & TAX from PO if available
                const vatPercentage = resp.purchase.vat || 0;
                const taxPercentage = resp.purchase.tax || 0;
                const creditDays = resp.purchase.creditDays || 0;

                
                setPurchaseRows(poRows);
                
                // Calculate total amount from rows
                const totalAmount = poRows.reduce((sum: number, row: any) => sum + (row.amount || 0), 0);
                
                // Calculate VAT & TAX amounts
                const vatAmount = (totalAmount * Number(vatPercentage)) / 100;
                const taxAmount = (totalAmount * Number(taxPercentage)) / 100;
                const purchaseAmount = totalAmount + vatAmount + taxAmount;
                
                // Set VAT & TAX percentages and calculated amounts
                setPurchase({ 
                    ...purchase, 
                    idPo: po.value, 
                    lcNo: resp.purchase.lcNo, 
                    idVendors: resp.purchase.id_vendors,
                    vatPercentage: vatPercentage,
                    vatAmount: vatAmount,
                    taxPercentage: taxPercentage,
                    taxAmount: taxAmount,
                    purchaseAmount: purchaseAmount,
                    creditDays: creditDays
                });
                
                console.log(poRows, 'poRows')

            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })

    }

    const handleVendorChange = (vendor: any) => {
        setVendor(vendor);
        setPurchase({ ...purchase, idVendors: vendor.value });
    }

    const handleItemChange = (data: any, index: number) => {
        const updatedPurchaseRows = [...purchaseRows];
        updatedPurchaseRows[index].idItems = data.value;
        updatedPurchaseRows[index].rate = 0;
        setPurchaseRows(updatedPurchaseRows);
    }

    const getItems = () => {

        fetch(
            process.env.REACT_APP_API_URL + 'production-items',
            getRequestOptions()
        )
            .then((resp) => {
                return resp.json()
            })
            .then((resp) => {

                let items = resp.data.map((item: any) => {
                    item.label = item.itemName;
                    item.value = item.idItems;
                    return item
                })
                setItems(items);

            })
            .catch((error) => {
                console.log(error, 'catch the hoop')
            })
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
        const updatedPurchaseRows = [...purchaseRows];
        const fieldName = e.target.name;
        const fieldValue = parseFloat(e.target.value) || 0;
        
        // Get current row data
        const currentRow = updatedPurchaseRows[index];
        const poQuantity = currentRow.poQuantity || 0;
        const receivedQuantity = currentRow.receivedQuantity || 0;
        const returnedQuantity = currentRow.returnedQuantity || 0;
        
        // Validation for return quantity
        if (fieldName === 'returnQuantity') {
            // Check if return quantity exceeds order quantity
            if (fieldValue > poQuantity) {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Return Quantity',
                    text: `Return quantity cannot exceed order quantity (${poQuantity})`,
                });
                return; // Don't update if validation fails
            }
            
            // Calculate total received quantity (previous + current receive qty)
            // Use the current value from the input field, not from state
            const currentReceiveQty = Number(updatedPurchaseRows[index].quantity) || 0;
            const totalReceivedQty = receivedQuantity + currentReceiveQty;
            const totalReturnLimit = totalReceivedQty + returnedQuantity + fieldValue; // Subtract already returned quantity
            
            if (totalReturnLimit > poQuantity) {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Return Quantity',
                    text: `Return quantity (${fieldValue}) cannot exceed available return limit (${totalReturnLimit}). Total received: ${totalReceivedQty}, Already returned: ${returnedQuantity}`,
                });
                return; // Don't update if validation fails
            }
            
            if (fieldValue < 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Return Quantity',
                    text: 'Return quantity cannot be negative',
                });
                return; // Don't update if validation fails
            }
        }
        
        // Validation for quantity (receiving quantity)
        if (fieldName === 'quantity') {
            // Check if receive quantity exceeds order quantity
            if (fieldValue > poQuantity) {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Receive Quantity',
                    text: `Receive quantity cannot exceed order quantity (${poQuantity})`,
                });
                return; // Don't update if validation fails
            }
            
            const maxReceivable = poQuantity - receivedQuantity - returnedQuantity;
            
            if (fieldValue > maxReceivable) {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Receive Quantity',
                    text: `Cannot receive more than available quantity. Maximum receivable: ${maxReceivable}`,
                });
                return; // Don't update if validation fails
            }
            
            if (fieldValue < 0) {
                Swal.fire({
                    icon: 'error',
                    title: 'Invalid Receive Quantity',
                    text: 'Receive quantity cannot be negative',
                });
                return; // Don't update if validation fails
            }
        }
        
        updatedPurchaseRows[index][fieldName] = fieldValue;

        // Recalculate amount based on effective quantity (quantity - return quantity)
        if (fieldName === 'quantity' || fieldName === 'returnQuantity' || fieldName === 'rate') {
            const quantity = Number(updatedPurchaseRows[index].quantity) || 0;
            const rate = Number(updatedPurchaseRows[index].rate) || 0;
            updatedPurchaseRows[index].amount = parseFloat((quantity * rate).toFixed(2));
        }

        setPurchaseRows(updatedPurchaseRows);
        // VAT & TAX will be recalculated by useEffect when purchaseRows changes
    }
    
    const handleVatOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const vatPercentage = parseFloat(event.target.value) || 0;
        calculateVatTax(vatPercentage, purchase.taxPercentage);
    }

    const handleTaxOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const taxPercentage = parseFloat(event.target.value) || 0;
        calculateVatTax(purchase.vatPercentage, taxPercentage);
    }
    
    const calculateVatTax = (vatPercent?: number, taxPercent?: number) => {
        const totalAmount = calculateTotalAmount();
        const vatPercentage = vatPercent !== undefined ? vatPercent : purchase.vatPercentage;
        const taxPercentage = taxPercent !== undefined ? taxPercent : purchase.taxPercentage;
        
        const vatAmount = (totalAmount * Number(vatPercentage)) / 100;
        const taxAmount = (totalAmount * Number(taxPercentage)) / 100;
        const purchaseAmount = totalAmount + vatAmount + taxAmount;
        
        setPurchase({
            ...purchase,
            vatPercentage: vatPercentage,
            taxPercentage: taxPercentage,
            vatAmount: vatAmount,
            taxAmount: taxAmount,
            purchaseAmount: purchaseAmount
        });
    }

    const deleteItem = (index: number) => {
        const updatedPurchaseRows = [...purchaseRows];
        if (updatedPurchaseRows && updatedPurchaseRows[index]) {
            updatedPurchaseRows.splice(index, 1);
            setPurchaseRows(updatedPurchaseRows);
        }
    }

    const addItem = (index: number) => {
        const newRow: PurchaseRows = {
            idPoRows: 0,
            idItems: 0,
            idProducts: 0,
            poQuantity: 0,
            receivedQuantity: 0,
            returnedQuantity: 0,
            returnQuantity: 0,
            quantity: 0,
            rate: 0,
            amount: 0,
        };

        const updatedRows = [...purchaseRows];
        updatedRows.push(newRow);

        setPurchaseRows(updatedRows);
    }

    const handleInputOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPurchase({ ...purchase, [event.target.name]: event.target.value });
    }

    const handleSelectOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {

        setProject({ label: 'Select Project', value: '' });
        setPo({ label: 'Select PO', value: '' });
        setPurchaseOrders([]);
        setVendor({ label: 'Select Vendor', value: '' });
        setPurchase({ ...purchase, idPo: 0, lcNo: '', invoiceNo: '', idVendors: 0, vatPercentage: 0, vatAmount: 0, taxPercentage: 0, taxAmount: 0 })
        setPurchaseRows([{
            idPoRows: 0,
            idItems: 0,
            poQuantity: 0,
            receivedQuantity: 0,
            returnedQuantity: 0,
            returnQuantity: 0,
            quantity: 0,
            rate: 0,
            amount: 0,
        }])
        setPurchase({ ...purchase, [event.target.id]: event.target.value });
    };

    const calculateTotalAmount = () => {
        let totalAmount = 0;

        for (const row of purchaseRows) {
            totalAmount += row.amount;
        }
        return totalAmount;
    };
    
    const purchaseSave = async (event: any) => {
        event.preventDefault();
        // Ensure purchaseAmount is calculated with VAT & TAX
        const totalAmount = calculateTotalAmount();
        const vatAmount = (totalAmount * Number(purchase.vatPercentage || 0)) / 100;
        const taxAmount = (totalAmount * Number(purchase.taxPercentage || 0)) / 100;
        const purchaseAmount = totalAmount + vatAmount + taxAmount;
        setPurchase({ ...purchase, purchaseAmount: purchaseAmount, vatAmount: vatAmount, taxAmount: taxAmount });

        const confirm = await Swal.fire({
            title: 'Are you sure?',
            text: "You want to create this Goods Receive?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#ec008c',
            cancelButtonText: 'Cancel',
            confirmButtonText: 'Yes, Create it!',
        });
        if (confirm.value) {
            const postData = {
                purchase: { ...purchase, idWarehouses: warehouse.value },
                purchaseRows: purchaseRows,
            };
            const requestOptions = postRequestOptions(postData);
            try {
                let response = await fetch(
                    `${process.env.REACT_APP_API_URL}purchase`,
                    requestOptions
                );
                let respData = await response.json();
                if (respData.success === true) {
                    const successMsg = respData.successMessage;
                    Swal.fire({
                        icon: 'success',
                        title: 'Success',
                        text: successMsg,
                    });
                    history.push("/purchase");
                } else {
                    const errorsMessage = validationErrorMsg(respData.errors).join('<br>');
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        html: errorsMessage,
                    });
                }
            } catch (error) {
                console.log(error, 'catch the hoop');
            }
        }
    };

    return (

        <div className="card card-custom">
            <div className="card-header">
                <div className="card-title">
                    <KTSVG
                        path='/media/svg/icons/Home/Book-open.svg'
                        className='svg-icon-1 svg-icon-primary'
                    />
                    <span className="text fw-bolder" style={{ marginLeft: "10px" }}>
                        Create Goods Receive
                    </span>
                </div>
            </div>

            <div className="ml-12">
                <div className="card-body">

                    <form onSubmit={purchaseSave}>
                        <div className="form-group row">
                            <label htmlFor="purchaseType" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Receive Type <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <select name="purchaseType" id="purchaseType" onChange={handleSelectOnChange} className="form-control form-control-sm">
                                    <option value={'Local Purchase'}>Local Purchase</option>
                                    <option value={'LC'}>LC</option>
                                </select>
                            </div>
                        </div>
                        
                        <div className="form-group row">
                            <label htmlFor="idProjects" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Project <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={project}
                                    onChange={handleProjectChange}
                                    options={projects}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idWarehouses" className="col-lg-3 col-form-label" style={{ textAlign: "right" }}>Select Warehouse <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={warehouse}
                                    onChange={handleWarehouseChange}
                                    options={warehouses}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isDisabled={warehouses.length === 0}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idPo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select PO <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={po}
                                    onChange={handlePoChange}
                                    options={purchaseOrders}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="idVendors" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Select Vendor <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <Select
                                    value={vendor}
                                    onChange={handleVendorChange}
                                    options={vendors}
                                    menuPosition="fixed"
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    isDisabled={purchase.purchaseType === 'Local Purchase' || purchase.purchaseType === 'LC'}
                                />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="purchaseDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Receive Date <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <input type='date' name="purchaseDate" id="purchaseDate" onChange={handleInputOnChange} className="form-control form-control-sm" />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="creditDays" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Credit Days</label>
                            <div className="col-lg-5">
                                <input type='number' name="creditDays" id="creditDays" value={purchase.creditDays || ''} onChange={handleInputOnChange} className="form-control form-control-sm" readOnly />
                            </div>
                        </div>
                        {
                            purchase.purchaseType === 'LC' && (
                                <div className="form-group row mb-2">
                                    <label htmlFor="lcNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>LC No <span className="required text-danger"></span></label>
                                    <div className="col-lg-5">
                                        <input name="lcNo" id="lcNo" value={purchase.lcNo} onChange={handleInputOnChange} className="form-control form-control-sm" readOnly />
                                    </div>
                                </div>
                            )
                        }
                        {
                            purchase.purchaseType === 'LC' && (
                                <div className="form-group row mb-2">
                                    <label htmlFor="invoiceNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Invoice No <span className="required text-danger"></span></label>
                                    <div className="col-lg-5">
                                        <input
                                            name="invoiceNo"
                                            id="invoiceNo"
                                            value={purchase.invoiceNo}
                                            onChange={handleInputOnChange}
                                            className="form-control form-control-sm"
                                            required={purchase.purchaseType === 'LC'}
                                        />
                                    </div>
                                </div>
                            )
                        }

                        <div className="form-group row mb-2">
                            <label htmlFor="chalanNo" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Chalan No <span className="required text-danger"></span></label>
                            <div className="col-lg-5">
                                <input name="chalanNo" id="chalanNo" onChange={handleInputOnChange} className="form-control form-control-sm" required />
                            </div>
                        </div>
                        <div className="form-group row">
                            <label htmlFor="chalanDate" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Chalan Date</label>
                            <div className="col-lg-5">
                                <input type='date' name="chalanDate" id="chalanDate" onChange={handleInputOnChange} className="form-control form-control-sm" />
                            </div>
                        </div>
                        <div className="form-group row mb-2">
                            <label htmlFor="remarks" className="col-lg-3 col-form-label" style={{ "textAlign": "right" }}>Remarks</label>
                            <div className="col-lg-5">
                                <input name="remarks" id="remarks" onChange={handleInputOnChange} className="form-control form-control-sm" />
                            </div>
                        </div>

                        <br></br>
                        {poPurpose && purchase.idPo > 0 && (
                            <div className="mb-2">
                                <span className={`badge ${isFinishedProduct ? 'badge-info' : 'badge-success'}`}>
                                    Purpose: {poPurpose}
                                </span>
                            </div>
                        )}
                        <Table size='sm' bordered hover>
                            <thead>
                                <tr>
                                    <th style={{ width: '5%' }} className='text-center'>SL</th>
                                    <th style={{ width: '35%' }}>{nameColumnLabel} <span className='text-danger'>*</span> </th>
                                    <th style={{ width: '10%' }}>Rate</th>
                                    <th style={{ width: '15%' }}>Receive Qty</th>
                                    <th style={{ width: '10%' }}>Return Qty</th>
                                    <th style={{ width: '10%' }}>Amount</th>
                                    <th style={{ width: '10%' }}></th>
                                </tr>
                            </thead>

                            <tbody>

                                {purchaseRows.map((row, index) => (
                                    <tr key={'item-' + index}>
                                        <td className='text-center'>{index + 1}</td>
                                        <td>
                                            <Select
                                                placeholder={row.itemName || (isFinishedProduct ? 'Select Product' : 'Select Item')}
                                                value={row.itemName ? { label: row.itemName, value: isFinishedProduct ? row.idProducts : row.idItems } : null}
                                                onChange={(selectedOption) => handleItemChange(selectedOption, index)}
                                                options={items}
                                                className='sm'
                                                menuPosition="fixed"
                                                styles={{
                                                    control: (provided, state) => ({
                                                        ...provided,
                                                        height: '32px',
                                                        minHeight: '32px',
                                                    }),
                                                    container: (provided, state) => ({
                                                        ...provided,
                                                        height: '32px',
                                                    }),
                                                }}
                                                isDisabled={purchase.purchaseType === 'Local Purchase' || isFinishedProduct}
                                            />
                                        </td>
                                        <td>
                                            <input 
                                                type="number" 
                                                name="rate" 
                                                value={row.rate} 
                                                onChange={(event) => handleChange(event, index)} 
                                                className="form-control form-control-sm" 
                                                readOnly={purchase.purchaseType === 'Local Purchase'} 
                                            />
                                        </td>
                                        <td>
                                            <input 
                                                type="number" 
                                                name="quantity" 
                                                value={row.quantity} 
                                                onChange={(event) => handleChange(event, index)} 
                                                className="form-control form-control-sm"
                                                min="0"
                                                max={row.poQuantity || undefined}
                                                step="any"
                                                title={row.poQuantity > 0 ? `Maximum receivable: ${Math.min(row.poQuantity, row.poQuantity - row.receivedQuantity)} (Order Qty: ${row.poQuantity})` : ''}
                                            />
                                            {row.poQuantity > 0 && (
                                                <> {/* Wrap in a fragment to avoid unnecessary DOM nodes */}
                                                    <small><strong>{row.poQuantity}</strong> ordered </small>
                                                    <small><strong>{row.receivedQuantity}</strong> received </small>
                                                    <small><strong>{row.returnedQuantity || 0}</strong> already returned </small>
                                                    <small><strong>{row.returnQuantity || 0}</strong> current return </small>
                                                    {(() => {
                                                        const available = row.poQuantity - row.receivedQuantity - (row.returnedQuantity || 0) - (row.returnQuantity || 0);
                                                        if (available <= 0) {
                                                            return <small className='text-danger'>(No quantity available to receive)</small>;
                                                        } else {
                                                            return <small className='text-success'><strong>{available}</strong> available</small>;
                                                        }
                                                    })()}
                                                </>
                                            )}
                                        </td>
                                        <td>
                                            <input 
                                                type="number" 
                                                name="returnQuantity" 
                                                value={row.returnQuantity} 
                                                onChange={(event) => handleChange(event, index)} 
                                                className="form-control form-control-sm"
                                                min="0"
                                                max={Math.min(row.poQuantity || 0, row.receivedQuantity + (row.quantity || 0))}
                                                step="any"
                                                title={`Maximum return quantity: ${Math.min(row.poQuantity || 0, row.receivedQuantity + (row.quantity || 0))} (Cannot exceed order qty: ${row.poQuantity})`}
                                            />
                                        </td>
                                        <td>
                                            <input type="number" name="amount" readOnly value={row.amount} className="form-control form-control-sm" />
                                        </td>
                                        <td>
                                            {
                                                purchaseRows.length > 1 &&
                                                <button type='button' className="btn btn-light-primary btn-sm px-2 py-1" onClick={() => deleteItem(index)}>
                                                    <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon-danger me-0' />
                                                </button>
                                            }

                                            {index === purchaseRows.length - 1 && purchase.purchaseType === 'LC' && (
                                                <button type='button' className="btn btn-success btn-sm px-2 py-1" onClick={() => addItem(index)}>
                                                    <KTSVG path='/media/svg/icons/Navigation/Plus.svg' className='svg-icon-5 svg-icon-danger me-0' /> Add
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}

                                <tr>
                                    <td colSpan={5} className='text-end'><b>Total Amount:</b></td>
                                    <td><b>{numberFormat(calculateTotalAmount())}</b></td>
                                    <td></td>
                                </tr>

                            </tbody>

                        </Table>
                        
                        <div className="row mt-4">
                            <div className="col-6"></div>
                            <div className="col-6">
                                <div className='notice bg-light-primary rounded border-primary border border-dashed h-lg-100 p-6'>
                                    <div className="row mt-2">
                                        <div className="col-md-5"><strong>Total Amount: </strong></div>
                                        <div className="col-md-4">
                                            {numberFormat(calculateTotalAmount())}
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-5"><strong>VAT: </strong></div>
                                        <div className="col-md-4">
                                            <div className="input-group input-group-sm mb-3">
                                                <input 
                                                    type='number' 
                                                    name="vatPercentage" 
                                                    value={purchase.vatPercentage || ''} 
                                                    onChange={handleVatOnChange} 
                                                    className="form-control form-control-sm" 
                                                    min={0} 
                                                    step={'any'} 
                                                />
                                                <span className="input-group-text">%</span>
                                                <input 
                                                    type='number' 
                                                    name="vatAmount" 
                                                    id="vatAmount" 
                                                    value={purchase.vatAmount || 0} 
                                                    className="form-control form-control-sm" 
                                                    readOnly 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-5"><strong>TAX: </strong></div>
                                        <div className="col-md-4">
                                            <div className="input-group input-group-sm mb-3">
                                                <input 
                                                    type='number' 
                                                    name="taxPercentage" 
                                                    value={purchase.taxPercentage || ''} 
                                                    onChange={handleTaxOnChange} 
                                                    className="form-control form-control-sm" 
                                                    min={0} 
                                                    step={'any'} 
                                                />
                                                <span className="input-group-text">%</span>
                                                <input 
                                                    type='number' 
                                                    name="taxAmount" 
                                                    id="taxAmount" 
                                                    value={purchase.taxAmount || 0} 
                                                    className="form-control form-control-sm" 
                                                    readOnly 
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row mt-2">
                                        <div className="col-md-5"><strong>Net Amount: </strong></div>
                                        <div className="col-md-4">
                                            {numberFormat(purchase.purchaseAmount || calculateTotalAmount())}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row mt-4">
                            <div className="col-12 text-center">
                                <button type="submit" className="btn btn-sm btn-primary me-2">
                                    <span>  Submit</span>
                                </button>
                                <Link to='/purchase' type="reset" className="btn btn-sm btn-secondary">Cancel</Link>
                            </div>
                        </div>
                        {/* <pre>{JSON.stringify(purchase, null, 2)}</pre>
                        <pre>{JSON.stringify(purchaseRows, null, 2)}</pre> */}
                    </form>

                </div>
            </div>
        </div>

    )
}

export default PurchaseCreate
